const rssFeed = Array.from(document.querySelectorAll('.feedzy-rss'));
const rssFeedData = rssFeed.map(el => (
  {
    container: el,
    rssLinkSpan: Array.from(el.querySelectorAll('.rss_item div a span')),
  }
));

const LOW_RES_IMG = 'hqdefault';
const HIGH_RES_IMG = 'maxresdefault';

const hasRssFeed = () => {
  return rssFeed.length;
};

window.addEventListener('load', () => {
  if(hasRssFeed()) {
    rssFeedData.forEach(rssFeedBox => {
      rssFeedInit(rssFeedBox);
    });
  }
});

const rssFeedInit = (rssFeedData) => {
  imageSwitcher(rssFeedData, LOW_RES_IMG, HIGH_RES_IMG);
};

const imageSwitcher = (obj, target, replacement)=> {
  // rss feedのspanタグからURLの部分だけを取得
  const arrayOfSpanUrl = obj.rssLinkSpan.map(link => {
    const backgroundImage = getComputedStyle(link).backgroundImage;
    if (backgroundImage && backgroundImage !== 'none') {
      const matchResult = backgroundImage.match(/url\(["']?(.*?)["']?\)/);
      if (matchResult && matchResult.length > 1) {
        return matchResult[1];
      }
    }
    return null;
  }).filter(url => url !== null); // null をフィルタリング
  
  // 高画質用の画像URLに変換
  for(let i=0; i < arrayOfSpanUrl.length; i++) {
    if(arrayOfSpanUrl[i].includes(target)) {
      arrayOfSpanUrl[i] = arrayOfSpanUrl[i].replace(target, replacement)
    }
  }

  // spanをimgと置換
  obj.rssLinkSpan.forEach((el, index) => {
    const imgElement = document.createElement('img');
    imgElement.src =arrayOfSpanUrl[index];
    imgElement.style.width = '100%';
    imgElement.style.height = '100%';
    el.parentNode.replaceChild(imgElement, el);
  });
};
